// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.artwork-dsbp {
  height: 100%;
  padding-top: 8px;
  position: relative;
}
.artwork-dsbp .multiselect-padding {
  margin-bottom: 10px;
}
.artwork-dsbp .margin-left {
  margin-left: 20px;
}
.artwork-dsbp .margin-right {
  margin-right: 20px;
}
.artwork-dsbp .p-datatable {
  height: calc(100% - 170px);
}
@media only screen and (max-width: 768px) {
  .artwork-dsbp .p-datatable {
    height: 100%;
    max-height: 30vh;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .artwork-dsbp .p-datatable {
    height: calc(100% - 210px);
  }
}
.artwork-dsbp .p-datatable tr {
  height: 38px !important;
}
.artwork-dsbp .p-datatable td,
.artwork-dsbp .p-datatable th {
  min-width: 160px;
  max-width: 280px;
}
.artwork-dsbp .p-datatable .p-datatable-wrapper {
  height: 90% !important;
}
.artwork-dsbp .p-multiselect .p-multiselect-label.p-placeholder {
  color: #595959;
  font-size: 12px;
  font-weight: 500;
  line-height: 10px;
}
.artwork-dsbp .p-multiselect .p-multiselect-label {
  font-size: 12px;
}
.artwork-dsbp .header-buttons {
  gap: 6px;
  align-items: center;
  display: flex;
  flex-direction: row;
}
.artwork-dsbp .form-buttons {
  padding: 10px;
  position: absolute;
  background: white;
  text-align: right;
  width: 100%;
  left: 0;
}
.artwork-dsbp .footer {
  left: 5px;
}

.mddm-edit-icon {
  margin-left: 10px;
  height: 20px;
  cursor: pointer;
  font-size: 2rem;
  color: #003da5;
  width: 18px;
  height: 18px;
  position: absolute;
  top: 5px;
  right: 5px;
}

.artwork-dsbp {
  padding-top: 8px;
  position: relative;
}
.artwork-dsbp .multiselect-padding {
  margin-bottom: 10px;
}
.artwork-dsbp .margin-left {
  margin-left: 10px;
}
.artwork-dsbp .margin-right {
  margin-right: 20px;
}
.artwork-dsbp .p-multiselect .p-multiselect-label.p-placeholder {
  color: #595959;
  font-size: 12px;
  font-weight: 500;
  line-height: 10px;
}
.artwork-dsbp .p-multiselect .p-multiselect-label {
  font-size: 12px;
}
.artwork-dsbp .header-buttons {
  gap: 6px;
  align-items: center;
  display: flex;
  flex-direction: row;
}
.artwork-dsbp .form-buttons {
  position: absolute;
  background: white;
  text-align: right;
  width: 100%;
  left: 0;
  bottom: 0;
}

.addToProjectTable.p-datatable.p-datatable-scrollable > .p-datatable-wrapper > .p-datatable-table > .p-datatable-thead, .addToProjectTable.p-datatable .p-datatable-thead > tr > th {
  background: white;
  border: 0;
  padding: 0;
}
.addToProjectTable.p-datatable .p-datatable-tbody > tr > td {
  border: 0;
  padding-left: 0;
}
.addToProjectTable.p-datatable .p-datatable-tbody > tr:first-child td {
  padding-top: 7px;
}

.dsbp-select .p-inputwrapper-filled {
  border: 1px solid #ced4da !important;
}

.dsbp-multiselect-dropdown .p-checkbox {
  display: none;
}
.dsbp-multiselect-dropdown .p-multiselect-close {
  display: none;
}
.dsbp-multiselect-dropdown .p-multiselect-items .p-multiselect-item {
  flex-direction: row;
  padding: 0px 9px !important;
}
.dsbp-multiselect-dropdown .p-multiselect-header .p-multiselect-filter-container .p-inputtext {
  width: 100%;
}
.dsbp-multiselect-dropdown .p-multiselect-items-wrapper {
  padding: 0px !important;
}
.dsbp-multiselect-dropdown .city-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 7px;
  padding-bottom: 7px;
  color: black;
}
.dsbp-multiselect-dropdown .dropdown-name-color {
  color: black;
  font-weight: bold;
}
.dsbp-multiselect-dropdown .city-name {
  flex: 1 1;
  width: 600px;
}
.dsbp-multiselect-dropdown .add-new-design-intent-icon,
.dsbp-multiselect-dropdown .header-icons {
  margin-left: 10px;
  /* Add appropriate margin */
  height: 20px;
}
.dsbp-multiselect-dropdown .disable-icons {
  opacity: 0.2;
  pointer-events: none;
}
.dsbp-multiselect-dropdown .ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

a.tabView {
  cursor: pointer;
  color: #003da5;
  text-decoration: none;
}

.header-buttons {
  gap: 6px;
  align-items: center;
  display: flex;
  flex-direction: row;
}

.form-buttons {
  position: absolute;
  background: white;
  text-align: right;
  width: 100%;
  left: 0;
  bottom: 0;
}

.change-bg-color {
  background-color: #003da5;
}

.dependency-mapping {
  height: 100%;
  overflow: hidden;
}
.dependency-mapping tr {
  height: 36px !important;
}
.dependency-mapping td,
.dependency-mapping th {
  min-width: 180px;
  max-width: 250px;
}
.dependency-mapping .flex-display {
  display: flex;
}
.dependency-mapping .actions {
  padding: 8px 20px 0;
}
.dependency-mapping ._loading_overlay_wrapper {
  height: 100%;
}
.dependency-mapping .p-datatable {
  height: calc(100% - 130px);
}
@media only screen and (max-width: 1024px) {
  .dependency-mapping .p-datatable {
    height: calc(100% - 200px);
  }
}
.dependency-mapping .p-datatable .p-datatable-wrapper {
  height: 100%;
}
.dependency-mapping .form-buttons {
  padding: 10px;
  position: absolute;
  background: white;
  text-align: right;
  width: 100%;
  left: 0;
  bottom: 15px;
}
.dependency-mapping .footer {
  left: 5px;
}
.dependency-mapping .p-multiselect .p-multiselect-label {
  padding: 5px 3px 5px 5px;
  text-align: initial;
  font-size: 12px;
}
.dependency-mapping table thead th {
  text-align: left;
  border-width: 1px 2px 3px 4px;
  padding: 0 !important;
}
.dependency-mapping table thead th:nth-child(1) {
  border-left: none !important;
}
.dependency-mapping table thead th:last-child {
  border-left: none !important;
}
.dependency-mapping table thead th.p-filter-column .p-column-filter .p-fluid {
  min-width: 100px;
  border-radius: 140px;
}
.dependency-mapping table thead .p-filter-column {
  background-color: #ffffff !important;
  padding: 10px !important;
}
.dependency-mapping table .p-datatable .p-datatable-tbody > tr {
  font-size: 12px;
}
.dependency-mapping table .p-datatable-tbody > tr > td .awm-job-seperator {
  margin-right: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dependency-mapping table .p-datatable-tbody > tr > td .awm-job-seperator + .awm-job-seperator {
  padding-top: 5px;
  margin-top: 5px;
  border-top: 1px solid #595959;
}
.dependency-mapping table .pink-bg-color {
  background-color: #fff8ee !important;
}
.dependency-mapping table .white-bg-color {
  background-color: #ffffff !important;
}
.dependency-mapping table .blue-bg-color {
  background: #edf4fa !important;
}
.dependency-mapping table .selected-row {
  background-color: #e1edf8 !important;
}
.dependency-mapping table .header-pink-bg-color {
  background: #ffefd8 !important;
}
.dependency-mapping table td,
.dependency-mapping table table .p-datatable .p-datatable-tbody > tr > td,
.dependency-mapping table th,
.dependency-mapping table tr {
  position: relative;
}
.dependency-mapping table td,
.dependency-mapping table .p-datatable .p-datatable-tbody > tr > td {
  border-bottom: 0.5px solid #acacac !important;
  font-size: 12px;
  border-top: 0.5px solid #acacac !important;
  color: #595959;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
  text-align: left;
}
.dependency-mapping table td:first-child,
.dependency-mapping table .p-datatable .p-datatable-tbody > tr > td:first-child {
  border-left: none !important;
}
.dependency-mapping table td:last-child,
.dependency-mapping table .p-datatable .p-datatable-tbody > tr > td:last-child {
  border-right: none !important;
}
.dependency-mapping table td .p-datatable > .p-datatable-wrapper,
.dependency-mapping table .p-datatable .p-datatable-tbody > tr > td .p-datatable > .p-datatable-wrapper {
  overflow: scroll;
  width: 100%;
}
.dependency-mapping table .p-inputtext {
  border-radius: 50px;
}
.dependency-mapping table .p-multiselect {
  width: 100%;
  max-width: 100%;
}
.dependency-mapping table .p-multiselect .p-multiselect-label {
  width: 100%;
  word-wrap: break-word;
  white-space: normal;
  overflow: hidden;
  line-height: 15px;
}
.dependency-mapping table .cic-button-alignment {
  display: inline-block;
}
.dependency-mapping table .cic-button-alignment .p-button {
  cursor: default;
  pointer-events: none;
}
.dependency-mapping table .cic-button-alignment .p-button.p-button-success, .dependency-mapping table .cic-button-alignment .p-button.p-button-secondary {
  line-height: 13px;
  padding: 3px 5px;
  display: block;
  cursor: pointer;
  pointer-events: auto;
}
.dependency-mapping table .p-multiselect .p-multiselect-label {
  padding: 5px 3px 5px 5px;
  text-align: initial;
  font-size: 12px;
}
.dependency-mapping table .p-multiselect .p-multiselect-trigger {
  width: 2rem;
}
.dependency-mapping table .p-column-title {
  font-weight: 400;
}
.dependency-mapping table .p-column-title .cicinfoicon {
  width: 24px;
  height: 24px;
  padding-left: 5px !important;
  cursor: pointer;
}
.dependency-mapping table .p-datatable {
  height: calc(100% - 170px);
}
.dependency-mapping table .p-datatable .p-datatable-wrapper {
  height: 100%;
}
.dependency-mapping table .border-color {
  border-color: red;
}
.dependency-mapping .cic-matrix-toggle-container {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}
.dependency-mapping .cic-matrix-text-nowrap {
  white-space: nowrap;
}
.dependency-mapping .cic-matrix-text-on {
  color: red;
}
.dependency-mapping .cic-matrix-text-on {
  color: blue;
}
.dependency-mapping .table-row {
  min-width: 350px;
}
.dependency-mapping .predecessor-select {
  background-color: #ffffff;
  border: 1px solid #808080;
  border-radius: 4px;
}

.dm-multiselect-dropdown {
  max-width: 35%;
}
.dm-multiselect-dropdown .p-multiselect-items .p-multiselect-item {
  display: flex !important;
  padding: 0px 9px !important;
}
.dm-multiselect-dropdown .p-multiselect-header .p-multiselect-filter-container .p-inputtext {
  width: 100%;
}
.dm-multiselect-dropdown .p-multiselect-items-wrapper {
  padding: 0px !important;
}
.dm-multiselect-dropdown .dependency-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 7px;
  padding-bottom: 7px;
}
.dm-multiselect-dropdown .dependency-options .option-name {
  text-wrap: balance;
  overflow-wrap: anywhere;
}
.dm-multiselect-dropdown .dropdown-name-color {
  color: black;
  font-weight: bold;
}
.dm-multiselect-dropdown .city-name {
  flex: 1 1;
  width: 600px;
}
.dm-multiselect-dropdown .add-new-design-intent-icon,
.dm-multiselect-dropdown .header-icons {
  margin-left: 10px;
  min-height: 20px;
}
.dm-multiselect-dropdown .disable-icons {
  opacity: 0.5;
  pointer-events: none;
}
.dm-multiselect-dropdown .ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dm-multiselect-dropdown .p-multiselect-panel,
.dm-multiselect-dropdown .p-multiselect-items-wrapper > ul > li > span > div {
  white-space: nowrap;
}

.dependency-mapping-tab-view {
  height: 100%;
}
.dependency-mapping-tab-view .border-color {
  border-color: red;
}

.xml-tooltip.p-tooltip .p-tooltip-text {
  padding: 2px;
  background-color: white;
  color: black;
  max-width: 200px;
  font-size: 10px;
}
.xml-tooltip.p-tooltip .p-tooltip-arrow {
  border-right-color: white;
}

#actionDialog {
  overflow-y: auto;
  width: 65vw;
}
#actionDialog .card {
  border: 0;
}
#actionDialog .selected-count {
  margin: 10px 0;
}
#actionDialog .invalid-pmp-message-container {
  display: flex;
  align-items: flex-start;
  text-align: left;
  gap: 10px;
  padding: 10px 5px;
}
#actionDialog .invalid-pmp-message-container .invalid-pmp-message {
  color: #d37302;
  margin-bottom: 0px !important;
}
#actionDialog .invalid-pmp-message-container .error-massage {
  color: #ff0000;
  font-size: 15px;
}
#actionDialog .invalid-pmp-message-container .error-icon {
  filter: invert(21%) sepia(100%) saturate(10000%) hue-rotate(0deg) brightness(100%) contrast(100%);
}
#actionDialog #actionDialog_header {
  word-break: break-word;
}

.group-name-error {
  color: "red";
  font-size: 11px;
  padding-top: 5px;
}

.p-tooltip.p-tooltip-top.tooltip-white-cic .p-tooltip-text {
  width: 279px;
  height: 80px;
  display: flex;
  color: inherit;
  font-weight: 400;
  line-height: 14.63px;
  text-align: left;
  align-items: center;
  white-space: pre-line;
  word-break: break-word;
  justify-content: center;
  background-color: white;
  border: 1px solid #fff7f7;
}
.p-tooltip.p-tooltip-top.tooltip-white-cic .p-tooltip-text ::after {
  left: 20%;
  top: 100%;
  content: "";
  position: absolute;
  border-style: solid;
  margin-left: -2.625rem;
  border-width: 0.625rem;
  border-color: black transparent transparent transparent;
}
.p-tooltip.p-tooltip-top.tooltip-white-cic .p-tooltip-arrow {
  content: "";
  top: 87%;
  left: 10%;
  position: absolute;
  border-width: 1rem;
  border-style: solid;
  margin-left: -0.313rem;
  border-color: white transparent transparent transparent;
}

.cursor-pointer {
  cursor: pointer;
}

.hidden-option {
  display: none;
}

/* Custom styles for the Mass Update CIC Mapping DataTable */
.custom-datatable {
  width: 100% !important;
  height: auto !important;
  min-height: 15vh !important;
  max-height: 55vh !important;
}
.custom-datatable .p-datatable-wrapper {
  min-height: 15vh !important;
  max-height: 55vh !important;
}
.custom-datatable .p-datatable-scrollable-body {
  overflow-y: auto;
}

.mucm-label {
  font-weight: bold !important;
}

.green-label {
  color: #008000;
}

.warning-label {
  color: #ff8c00;
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.pmp_column, .pmp_description_column {
  max-width: 250px !important;
  overflow: hidden !important;
}

.dependency-mapping .dropdown-item {
  padding: 8px 16px;
}

.invalid-pmp-error {
  font-size: 10px;
  color: #ff0000;
}

.actionpopup .p-dialog-header {
  padding: 15px 30px 15px 30px;
  word-wrap: break-word;
}

.poa-table {
  max-width: 250px;
  overflow: hidden;
}

.pmp-msg {
  font-size: 1rem;
  font-weight: 700;
  color: #003da5;
}

.wave-dropdown-alignment-AddtoProject {
  margin-top: -45px;
  position: absolute;
  margin-left: 400px;
}

.wave-dropdown-alignment-CreatePOAA {
  margin-top: -45px;
  position: absolute;
  margin-left: 475px;
}

.wave-dropdown-alignment-RecreatePOA {
  margin-top: -14px;
  display: flex;
}

.tag_link_to_other_jobs {
  color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  line-height: 1.5;
  font-size: 0.75rem;
  font-weight: 700;
  margin: 2px 0;
  padding: 0.15rem 0.4rem;
  border: none;
  border-radius: 6px;
}
.tag_link_to_other_jobs[disabled] {
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/DSBP/index.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;AAGE;EACE,kBAAA;AADJ;AAIE;EACE,0BAAA;AAFJ;AAII;EAHF;IAII,YAAA;IACA,gBAAA;EADJ;AACF;AAGI;EARF;IASI,0BAAA;EAAJ;AACF;AAEI;EACE,uBAAA;AAAN;AAGI;;EAEE,gBAAA;EACA,gBAAA;AADN;AAII;EACE,sBAAA;AAFN;AAME;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAJJ;AAOE;EACE,eAAA;AALJ;AAQE;EACE,QAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AANJ;AASE;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,OAAA;AAPJ;AAWE;EACE,SAAA;AATJ;;AAcA;EACE,iBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAXF;;AAkBA;EACE,gBAAA;EACA,kBAAA;AAfF;AAiBE;EACE,mBAAA;AAfJ;AAkBE;EACE,iBAAA;AAhBJ;AAmBE;EACE,kBAAA;AAjBJ;AAoBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAlBJ;AAqBE;EACE,eAAA;AAnBJ;AAsBE;EACE,QAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AApBJ;AAuBE;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;AArBJ;;AA2BE;EAEE,iBAAA;EACA,SAAA;EACA,UAAA;AAzBJ;AA6BI;EACE,SAAA;EACA,eAAA;AA3BN;AA8BI;EACE,gBAAA;AA5BN;;AAiCE;EAEE,oCAAA;AA/BJ;;AAoCE;EACE,aAAA;AAjCJ;AAoCE;EACE,aAAA;AAlCJ;AAqCE;EACE,mBAAA;EACA,2BAAA;AAnCJ;AAsCE;EACE,WAAA;AApCJ;AAuCE;EACE,uBAAA;AArCJ;AAwCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAtCJ;AAyCE;EACE,YAAA;EACA,iBAAA;AAvCJ;AA0CE;EACE,SAAA;EACA,YAAA;AAxCJ;AA2CE;;EAEE,iBAAA;EACA,2BAAA;EACA,YAAA;AAzCJ;AA4CE;EACE,YAAA;EACA,oBAAA;AA1CJ;AA6CE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA3CJ;;AA+CA;EACE,eAAA;EACA,cAAA;EACA,qBAAA;AA5CF;;AA+CA;EACE,QAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AA5CF;;AA+CA;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;AA5CF;;AA+CA;EACE,yBAAA;AA5CF;;AA+CA;EACE,YAAA;EACA,gBAAA;AA5CF;AA8CE;EACE,uBAAA;AA5CJ;AA+CE;;EAEE,gBAAA;EACA,gBAAA;AA7CJ;AAgDE;EACE,aAAA;AA9CJ;AAiDE;EACE,mBAAA;AA/CJ;AAkDE;EACE,YAAA;AAhDJ;AAmDE;EACE,0BAAA;AAjDJ;AAmDI;EAHF;IAII,0BAAA;EAhDJ;AACF;AAkDI;EACE,YAAA;AAhDN;AAoDE;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;AAlDJ;AA+DE;EACE,SAAA;AA7DJ;AAgEE;EACE,wBAAA;EACA,mBAAA;EACA,eAAA;AA9DJ;AAuEM;EAIE,gBAAA;EACA,6BAAA;EAEA,qBAAA;AAzER;AA2EQ;EACE,4BAAA;AAzEV;AA4EQ;EACE,4BAAA;AA1EV;AA+EM;EACE,gBAAA;EACA,oBAAA;AA7ER;AAiFM;EACE,oCAAA;EACA,wBAAA;AA/ER;AAuFI;EACE,eAAA;AArFN;AA2FM;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;AAzFR;AA4FM;EACE,gBAAA;EACA,eAAA;EACA,6BAAA;AA1FR;AA8FI;EACE,oCAAA;AA5FN;AA+FI;EACE,oCAAA;AA7FN;AAgGI;EACE,8BAAA;AA9FN;AAiGI;EACE,oCAAA;AA/FN;AAkGI;EACE,8BAAA;AAhGN;AA2HI;;;;EAIE,kBAAA;AAzHN;AA8HI;;EAGE,6CAAA;EAEA,eAAA;EAEA,0CAAA;EACA,cAAA;EAGA,2BAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EAEA,gBAAA;AAlIN;AAiJM;;EACE,4BAAA;AA9IR;AAiJM;;EACE,6BAAA;AA9IR;AAqJM;;EACE,gBAAA;EACA,WApYG;AAkPX;AAiKI;EACE,mBAAA;AA/JN;AAkKI;EACE,WAAA;EACA,eAAA;AAhKN;AAmKI;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAjKN;AAoKI;EACE,qBAAA;AAlKN;AAoKM;EACE,eAAA;EACA,oBAAA;AAlKR;AAoKQ;EAEE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AAnKV;AAwKI;EACE,wBAAA;EACA,mBAAA;EACA,eAAA;AAtKN;AAyKI;EACE,WAAA;AAvKN;AA0KI;EACE,gBAAA;AAxKN;AA0KM;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AAxKR;AA6KI;EACE,0BAAA;AA3KN;AA6KM;EACE,YAAA;AA3KR;AA+KI;EACE,iBAAA;AA7KN;AAiLE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AA/KJ;AAkLE;EACE,mBAAA;AAhLJ;AAmLE;EACE,UAAA;AAjLJ;AAoLE;EACE,WAAA;AAlLJ;AAqLE;EACE,gBAAA;AAnLJ;AAsLE;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;AApLJ;;AAwLA;EACE,cAAA;AArLF;AAuLE;EACE,wBAAA;EACA,2BAAA;AArLJ;AAwLE;EACE,WAAA;AAtLJ;AAyLE;EACE,uBAAA;AAvLJ;AA0LE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAxLJ;AA0LI;EACE,kBAAA;EACA,uBAAA;AAxLN;AA2LE;EACE,YAAA;EACA,iBAAA;AAzLJ;AA4LE;EACE,SAAA;EACA,YAAA;AA1LJ;AA6LE;;EAEE,iBAAA;EACA,gBAAA;AA3LJ;AA8LE;EACE,YAAA;EACA,oBAAA;AA5LJ;AA8LE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA5LJ;AA8LE;;EAEE,mBAAA;AA5LJ;;AAgMA;EACE,YAAA;AA7LF;AA+LE;EACE,iBAAA;AA7LJ;;AAkME;EACE,YAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA/LJ;AAkME;EACE,yBAAA;AAhMJ;;AAoMA;EACE,gBAAA;EACA,WAAA;AAjMF;AAmME;EACE,SAAA;AAjMJ;AAoME;EACE,cAAA;AAlMJ;AAqME;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;AAnMJ;AAqMI;EACE,cAAA;EACA,6BAAA;AAnMN;AAsMI;EACE,cAAA;EACA,eAAA;AApMN;AAuMI;EACE,iGAAA;AArMN;AAwME;EACE,sBAAA;AAtMJ;;AA0MA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AAvMF;;AA2ME;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;AAxMJ;AA0MI;EACE,SAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uDAAA;AAxMN;AA4ME;EACE,WAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uDAAA;AA1MJ;;AA8MA;EACE,eAAA;AA3MF;;AA8MA;EACE,aAAA;AA3MF;;AA8MA,4DAAA;AACA;EACE,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;AA3MF;AA4ME;EACE,2BAAA;EACA,2BAAA;AA1MJ;AA4ME;EACE,gBAAA;AA1MJ;;AA8MA;EACE,4BAAA;AA3MF;;AA6MA;EACE,cAAA;AA1MF;;AA6MA;EACE,cAAA;AA1MF;;AA4MA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAzMF;;AA4MA;EACE,2BAAA;EACA,2BAAA;AAzMF;;AA6ME;EACE,iBAAA;AA1MJ;;AA6MA;EACE,eAAA;EACA,cAAA;AA1MF;;AA4MA;EACE,4BAAA;EACA,qBAAA;AAzMF;;AA2MA;EACE,gBAAA;EACA,gBAAA;AAxMF;;AA2MA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAxMF;;AA2MA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;AAxMF;;AA2MA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;AAxMF;;AA2MA;EACE,iBAAA;EACA,aAAA;AAxMF;;AA2MA;EACE,WAAA;EACA,0JAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAxMF;AA0ME;EACE,mBAAA;AAxMJ","sourcesContent":[".artwork-dsbp {\n  height: 100%;\n  padding-top: 8px;\n  position: relative;\n\n  .multiselect-padding {\n    margin-bottom: 10px;\n  }\n\n  .margin-left {\n    margin-left: 20px;\n  }\n\n  .margin-right {\n    margin-right: 20px;\n  }\n\n  .p-datatable {\n    height: calc(100% - 170px);\n\n    @media only screen and (max-width: 768px) {\n      height: 100%;\n      max-height:30vh;\n    }\n\n    @media (min-width: 769px) and (max-width: 1024px) {\n      height: calc(100% - 210px);\n    }\n\n    tr {\n      height: 38px !important;\n    }\n\n    td,\n    th {\n      min-width: 160px;\n      max-width: 280px;\n    }\n\n    .p-datatable-wrapper {\n      height: 90% !important;\n    }\n  }\n\n  .p-multiselect .p-multiselect-label.p-placeholder {\n    color: #595959;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 10px;\n  }\n\n  .p-multiselect .p-multiselect-label {\n    font-size: 12px;\n  }\n\n  .header-buttons {\n    gap: 6px;\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n  }\n\n  .form-buttons {\n    padding: 10px;\n    position: absolute;\n    background: white;\n    text-align: right;\n    width: 100%;\n    left: 0;\n\n  }\n\n  .footer {\n    left: 5px;\n  }\n}\n\n\n.mddm-edit-icon {\n  margin-left: 10px;\n  height: 20px;\n  cursor: pointer;\n  font-size: 2rem;\n  color: #003da5;\n  width: 18px;\n  height: 18px;\n  position: absolute;\n  top: 5px;\n  right: 5px;\n}\n\n$width100: 100%;\n$fontWeight500: 500;\n$fontWeight400: 400;\n\n.artwork-dsbp {\n  padding-top: 8px;\n  position: relative;\n\n  .multiselect-padding {\n    margin-bottom: 10px;\n  }\n\n  .margin-left {\n    margin-left: 10px;\n  }\n\n  .margin-right {\n    margin-right: 20px;\n  }\n\n  .p-multiselect .p-multiselect-label.p-placeholder {\n    color: #595959;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 10px;\n  }\n\n  .p-multiselect .p-multiselect-label {\n    font-size: 12px;\n  }\n\n  .header-buttons {\n    gap: 6px;\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n  }\n\n  .form-buttons {\n    position: absolute;\n    background: white;\n    text-align: right;\n    width: 100%;\n    left: 0;\n    bottom: 0;\n  }\n}\n\n.addToProjectTable {\n\n  &.p-datatable.p-datatable-scrollable>.p-datatable-wrapper>.p-datatable-table>.p-datatable-thead,\n  &.p-datatable .p-datatable-thead>tr>th {\n    background: white;\n    border: 0;\n    padding: 0;\n  }\n\n  &.p-datatable .p-datatable-tbody {\n    >tr>td {\n      border: 0;\n      padding-left: 0;\n    }\n\n    >tr:first-child td {\n      padding-top: 7px;\n    }\n  }\n}\n.dsbp-select {\n  .p-inputwrapper-filled {\n    // border: 1px solid blue;\n    border: 1px solid #ced4da !important;\n  }\n}\n\n.dsbp-multiselect-dropdown {\n  .p-checkbox {\n    display: none;\n  }\n\n  .p-multiselect-close {\n    display: none;\n  }\n\n  .p-multiselect-items .p-multiselect-item {\n    flex-direction: row ;\n    padding: 0px 9px !important;\n  }\n\n  .p-multiselect-header .p-multiselect-filter-container .p-inputtext {\n    width: 100%;\n  }\n\n  .p-multiselect-items-wrapper {\n    padding: 0px !important;\n  }\n\n  .city-option {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 7px;\n    padding-bottom: 7px;\n    color: black;\n  }\n\n  .dropdown-name-color {\n    color: black;\n    font-weight: bold;\n  }\n\n  .city-name {\n    flex: 1;\n    width: 600px;\n  }\n\n  .add-new-design-intent-icon,\n  .header-icons {\n    margin-left: 10px;\n    /* Add appropriate margin */\n    height: 20px;\n  }\n\n  .disable-icons {\n    opacity: 0.2;\n    pointer-events: none;\n  }\n\n  .ellipsis {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\na.tabView {\n  cursor: pointer;\n  color: #003da5;\n  text-decoration: none;\n}\n\n.header-buttons {\n  gap: 6px;\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n}\n\n.form-buttons {\n  position: absolute;\n  background: white;\n  text-align: right;\n  width: 100%;\n  left: 0;\n  bottom: 0;\n}\n\n.change-bg-color {\n  background-color: #003da5;\n}\n\n.dependency-mapping {\n  height: 100%;\n  overflow: hidden;\n\n  tr {\n    height: 36px !important;\n  }\n\n  td,\n  th {\n    min-width: 180px;\n    max-width: 250px;\n  }\n\n  .flex-display {\n    display: flex;\n  }\n\n  .actions {\n    padding: 8px 20px 0;\n  }\n\n  ._loading_overlay_wrapper {\n    height: 100%;\n  }\n\n  .p-datatable {\n    height: calc(100% - 130px);\n\n    @media only screen and (max-width: 1024px) {\n      height: calc(100% - 200px);\n    }\n\n    .p-datatable-wrapper {\n      height: 100%;\n    }\n  }\n\n  .form-buttons {\n    padding: 10px;\n    position: absolute;\n    background: white;\n    text-align: right;\n    width: 100%;\n    left: 0;\n    bottom: 15px;\n  }\n\n  // .form-buttons {\n  //   padding: 0 10px;\n  //   position: absolute;\n  //   background: white;\n  //   text-align: right;\n  //   width: 100%;\n  //   left: 0;\n  //   // bottom: 35px;\n  // }\n\n  .footer {\n    left: 5px;\n  }\n\n  .p-multiselect .p-multiselect-label {\n    padding: 5px 3px 5px 5px;\n    text-align: initial;\n    font-size: 12px;\n  }\n\n  table {\n\n    // border-collapse: separate !important;\n    // border-spacing: 0 5px !important;\n    // width: 100%;\n    thead {\n      th {\n        // background-color: #edf4fa !important;\n        // height: 30px;\n        // border: 0 !important;\n        text-align: left;\n        border-width: 1px 2px 3px 4px;\n        // border: 0 !important;\n        padding: 0 !important;\n\n        &:nth-child(1) {\n          border-left: none !important;\n        }\n\n        &:last-child {\n          border-left: none !important;\n          // margin: 10px;\n        }\n      }\n\n      th.p-filter-column .p-column-filter .p-fluid {\n        min-width: 100px;\n        border-radius: 140px;\n        // background-color: #ffffff !important;\n      }\n\n      .p-filter-column {\n        background-color: #ffffff !important;\n        padding: 10px !important;\n      }\n    }\n\n    // tr:nth-child(even) > td {\n    //   background: #fafcff !important;\n    // }\n\n    .p-datatable .p-datatable-tbody>tr {\n      font-size: 12px;\n    }\n\n    .p-datatable-tbody>tr>td {\n      // white-space: normal !important;\n\n      .awm-job-seperator {\n        margin-right: 15px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .awm-job-seperator+.awm-job-seperator {\n        padding-top: 5px;\n        margin-top: 5px;\n        border-top: 1px solid #595959;\n      }\n    }\n\n    .pink-bg-color {\n      background-color: #fff8ee !important;\n    }\n\n    .white-bg-color {\n      background-color: #ffffff !important;\n    }\n\n    .blue-bg-color {\n      background: #edf4fa !important;\n    }\n\n    .selected-row {\n      background-color: #e1edf8 !important;\n    }\n\n    .header-pink-bg-color {\n      background: #ffefd8 !important;\n    }\n\n    // th:after,\n    // td:after {\n    //   content: \"\";\n    //   display: block;\n    //   height: 22px;\n    //   width: 0.8px;\n    //   background-color: #acacac;\n    //   position: absolute;\n    //   top: 25%;\n    //   right: 0;\n    // }\n\n    // th:after,\n    // td:after {\n    //   content: \"\";\n    //   display: block;\n    //   height: 22px;\n    //   width: 0.8px;\n    //   background-color: #acacac;\n    //   position: absolute;\n    //   top: 25%;\n    //   right: 0;\n    // }\n\n    td,\n    table .p-datatable .p-datatable-tbody>tr>td,\n    th,\n    tr {\n      position: relative;\n      // border: 0 !important;\n      // height: 40px;\n    }\n\n    td,\n    .p-datatable .p-datatable-tbody>tr>td {\n      // background-color: #003da5;\n      border-bottom: 0.5px solid #acacac !important;\n      // border-top: 1px solid #acacac !important;\n      font-size: 12px;\n      // line-height: 20px;\n      border-top: 0.5px solid #acacac !important;\n      color: #595959;\n      // text-align: center;\n      // background: #ffffff !important;\n      padding-top: 2px !important;\n      padding-bottom: 2px !important;\n      padding-left: 5px !important;\n      padding-right: 5px !important;\n      // border-width: 0.5px;\n      text-align: left;\n\n      // border: 2px solid gray !important;\n      // margin-top: 2px !important;\n      // margin-bottom: 2px !important;\n      // border-collapse: separate !important;\n      // border-spacing: 0 10px !important;\n      // border-left: 0px !important;\n      // border-right: 0px !important;\n      // &:first-child {\n      //   // border-top-left-radius: 14px;\n      //   // border-bottom-left-radius: 14px;\n      //   // border-left: 1px solid coral !important;\n      //   border-collapse: collapse;\n      // }\n      &:first-child {\n        border-left: none !important;\n      }\n\n      &:last-child {\n        border-right: none !important;\n        // border-top-right-radius: 14px;\n        // border-bottom-right-radius: 14px;\n        // background-color: #003da5;\n        // border-right: 1px solid #acacac !important;\n      }\n\n      .p-datatable>.p-datatable-wrapper {\n        overflow: scroll;\n        width: $width100;\n      }\n\n      // &:after {\n      //   // border-right: 2px solid black !important;\n      //   height: 40px !important;\n      //   // background-color:  #003da5 !important;\n      // }\n      // &:after {\n      //   // border-right: 2px solid black !important;\n      //   // height: 40px !important;\n      //   // background-color:  #003da5 !important;\n      // }\n    }\n\n    .p-inputtext {\n      border-radius: 50px;\n    }\n\n    .p-multiselect {\n      width: 100%;\n      max-width: 100%;\n    }\n\n    .p-multiselect .p-multiselect-label {\n      width: 100%;\n      word-wrap: break-word;\n      white-space: normal;\n      overflow: hidden;\n      line-height: 15px;\n    }\n\n    .cic-button-alignment {\n      display: inline-block;\n\n      .p-button {\n        cursor: default;\n        pointer-events: none;\n\n        &.p-button-success,\n        &.p-button-secondary {\n          line-height: 13px;\n          padding: 3px 5px;\n          display: block;\n          cursor: pointer;\n          pointer-events: auto;\n        }\n      }\n    }\n\n    .p-multiselect .p-multiselect-label {\n      padding: 5px 3px 5px 5px;\n      text-align: initial;\n      font-size: 12px;\n    }\n\n    .p-multiselect .p-multiselect-trigger {\n      width: 2rem;\n    }\n\n    .p-column-title {\n      font-weight: 400;\n\n      .cicinfoicon {\n        width: 24px;\n        height: 24px;\n        padding-left: 5px !important;\n        cursor: pointer;\n      }\n    }\n\n\n    .p-datatable {\n      height: calc(100% - 170px);\n\n      .p-datatable-wrapper {\n        height: 100%;\n      }\n    }\n\n    .border-color {\n      border-color: red;\n    }\n  }\n\n  .cic-matrix-toggle-container {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: nowrap;\n  }\n\n  .cic-matrix-text-nowrap {\n    white-space: nowrap;\n  }\n\n  .cic-matrix-text-on {\n    color: red;\n  }\n\n  .cic-matrix-text-on {\n    color: blue;\n  }\n\n  .table-row {\n    min-width: 350px;\n  }\n\n  .predecessor-select {\n    background-color: #ffffff;\n    border: 1px solid #808080;\n    border-radius: 4px;\n  }  \n}\n\n.dm-multiselect-dropdown {\n  max-width: 35%;\n\n  .p-multiselect-items .p-multiselect-item {\n    display: flex !important;\n    padding: 0px 9px !important;\n  }\n\n  .p-multiselect-header .p-multiselect-filter-container .p-inputtext {\n    width: 100%;\n  }\n\n  .p-multiselect-items-wrapper {\n    padding: 0px !important;\n  }\n\n  .dependency-options {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 7px;\n    padding-bottom: 7px;\n\n    .option-name {\n      text-wrap: balance;\n      overflow-wrap: anywhere;\n    }\n  }\n  .dropdown-name-color {\n    color: black;\n    font-weight: bold;\n  }\n\n  .city-name {\n    flex: 1;\n    width: 600px;\n  }\n\n  .add-new-design-intent-icon,\n  .header-icons {\n    margin-left: 10px;\n    min-height: 20px;\n  }\n\n  .disable-icons {\n    opacity: 0.5;\n    pointer-events: none;\n  }\n  .ellipsis {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .p-multiselect-panel,\n  .p-multiselect-items-wrapper > ul > li > span > div {\n    white-space: nowrap;\n  }\n}\n\n.dependency-mapping-tab-view {\n  height: 100%;\n\n  .border-color {\n    border-color: red;\n  }\n}\n\n.xml-tooltip.p-tooltip {\n  .p-tooltip-text {\n    padding: 2px;\n    background-color: white;\n    color: black;\n    max-width: 200px;\n    font-size: 10px;\n  }\n\n  .p-tooltip-arrow {\n    border-right-color: white;\n  }\n}\n\n#actionDialog {\n  overflow-y: auto;\n  width: 65vw;\n\n  .card {\n    border: 0;\n  }\n\n  .selected-count {\n    margin: 10px 0;\n  }\n\n  .invalid-pmp-message-container {\n    display: flex;\n    align-items: flex-start;\n    text-align: left;\n    gap: 10px;\n    padding: 10px 5px;\n\n    .invalid-pmp-message {\n      color: #d37302;\n      margin-bottom: 0px !important;\n    }\n\n    .error-massage{\n      color: #ff0000;\n      font-size: 15px;\n\n    }\n    .error-icon{\n      filter: invert(21%) sepia(100%) saturate(10000%) hue-rotate(0deg) brightness(100%) contrast(100%);\n    }\n  }\n  #actionDialog_header{\n    word-break: break-word; \n  }\n}\n\n.group-name-error {\n  color: \"red\";\n  font-size: 11px;\n  padding-top: 5px;\n}\n\n.p-tooltip.p-tooltip-top.tooltip-white-cic {\n  .p-tooltip-text {\n    width: 279px;\n    height: 80px;\n    display: flex;\n    color: inherit;\n    font-weight: 400;\n    line-height: 14.63px;\n    text-align: left;\n    align-items: center;\n    white-space: pre-line;\n    word-break: break-word;\n    justify-content: center;\n    background-color: white;\n    border: 1px solid #fff7f7;\n\n    ::after {\n      left: 20%;\n      top: 100%;\n      content: \"\";\n      position: absolute;\n      border-style: solid;\n      margin-left: -2.625rem;\n      border-width: 0.625rem;\n      border-color: black transparent transparent transparent;\n    }\n  }\n\n  .p-tooltip-arrow {\n    content: \"\";\n    top: 87%;\n    left: 10%;\n    position: absolute;\n    border-width: 1rem;\n    border-style: solid;\n    margin-left: -0.313rem;\n    border-color: white transparent transparent transparent;\n  }\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.hidden-option {\n  display: none;\n}\n\n/* Custom styles for the Mass Update CIC Mapping DataTable */\n.custom-datatable {\n  width: 100% !important; \n  height: auto !important;\n  min-height: 15vh !important;\n  max-height: 55vh !important;\n  .p-datatable-wrapper{\n    min-height: 15vh !important;\n    max-height: 55vh !important;\n  }\n  .p-datatable-scrollable-body {\n    overflow-y: auto; \n  }\n}\n\n.mucm-label {\n  font-weight: bold !important;\n}\n.green-label{\n  color: #008000;\n}\n\n.warning-label{\n  color: #ff8c00;\n}\n.ellipsis-text {\n  white-space: nowrap; \n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.pmp_column, .pmp_description_column {\n  max-width: 250px !important;\n  overflow: hidden !important;\n}\n\n.dependency-mapping{\n  .dropdown-item{\n    padding: 8px 16px;\n  }\n}\n.invalid-pmp-error {\n  font-size: 10px;\n  color: #ff0000;\n}\n.actionpopup .p-dialog-header {\n  padding: 15px 30px 15px 30px;\n  word-wrap: break-word;\n}\n.poa-table{\n  max-width: 250px;\n  overflow : hidden; \n}\n\n.pmp-msg {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #003da5;\n}\n\n.wave-dropdown-alignment-AddtoProject {\n  margin-top: -45px;\n  position: absolute;\n  margin-left: 400px\n}\n\n.wave-dropdown-alignment-CreatePOAA {\n  margin-top: -45px;\n  position: absolute;\n  margin-left: 475px\n}\n\n.wave-dropdown-alignment-RecreatePOA {\n  margin-top: -14px;\n  display: flex;\n}\n\n.tag_link_to_other_jobs {\n  color: #fff;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  line-height: 1.5;\n  font-size: 0.75rem;\n  font-weight: 700;\n  margin: 2px 0;\n  padding: 0.15rem 0.4rem;\n  border: none;\n  border-radius: 6px;\n\n  &[disabled] {\n    cursor: not-allowed;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
